import Cookies from 'js-cookie';
import { CURRENT_LANGUAGE } from './constants';

// 获取用户默认语言 用户切换过就会用切换后的语言
// 没有切换就是默认中文 但是目前是默认英文 会有点问题
export const getUserDefaultLanguage = () => {
  const cookieLanguage = Cookies.get(CURRENT_LANGUAGE);
  const navigatorLanguage = window.navigator.language.toLowerCase();

  let userLanguage = '';
  // 用户是否有选择过语言 优先使用选择语言
  if (cookieLanguage) {
    userLanguage = cookieLanguage.toLowerCase();
    // 浏览器默认语言
  } else if (navigatorLanguage.startsWith('zh')) {
    userLanguage = 'zh';
  } else {
    // 系统语言
    userLanguage = navigatorLanguage;
  }

  return userLanguage;
};

// 新的公开课 语言数据存在session
// 这个好像不对
export const getUserDefaultLanguageSession = (navigatorLanguage: string = '') => {
  const cookieLanguage = Cookies.get(CURRENT_LANGUAGE);

  let userLanguage = '';
  if (cookieLanguage) {
    userLanguage = cookieLanguage.toLowerCase();
  } else if (navigatorLanguage.startsWith('zh')) {
    userLanguage = 'zh';
  } else {
    userLanguage = navigatorLanguage;
  }

  return userLanguage;
};
